/**
 * Copyright (c) 2017 The xterm.js authors. All rights reserved.
 * @license MIT
 */

export const INVERTED_DEFAULT_COLOR = 257;

export const enum RendererConstants {
  /**
   * The idle time after which cursor blinking stops.
   */
  CURSOR_BLINK_IDLE_TIMEOUT = 5 * 60 * 1000
}
